<template>
    <div class="block">
        <van-nav-bar
                title="提货人注册"
                left-text=""
                left-arrow
                @click-left="back()"
        />
        <div  class="form-warp">
            <van-form >
                <van-field style="font-size: 16px" v-model="personname" left-icon="contact" label=" "
                           label-width="5px" placeholder="请输入姓名"  autocomplete="off"/>
                <van-field style="font-size: 16px" v-model="idcard" left-icon="credit-pay" label=" "
                           label-width="5px" placeholder="请输入身份证号码"/>
                <van-field style="font-size: 16px" v-model="tel" type="tel" left-icon="phone-o" label=" "
                           label-width="5px"  placeholder="请输入手机号码"/>
                <van-field style="font-size: 16px" v-model="msgCode" type="number"   left-icon="comment-o" label=" "
                           label-width="5px" placeholder="请输入验证码">
                    <template #button>
                        <a style="color: #6685a4;margin-right: 6px">{{buttonTxt}}</a>
                        <!--<van-button  size="small" type="info" :disabled="buttonStatus" @click="sendMsg()">{{buttonTxt}}</van-button>-->
                    </template>
                </van-field>
                <div style="margin: 16px;">
                <van-button color="#6685a4" block  type="info" native-type="submit" style="font-size: 16px" @click="register()">
                    提交
                </van-button>
                </div>
                <div class="agreewarp">
                    <van-checkbox  v-model="checked"  shape="square"  checked-color="#6685a4">我已阅读并同意<a @click.stop="showAgreement()">《用户服务协议》</a></van-checkbox>
                </div>
            </van-form>
        </div>
        <van-overlay :show="show" @click="show">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" color="#1989fa" vertical></van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import { NavBar,Form,Field ,Button ,Toast,Checkbox} from 'vant';
    import { Overlay } from 'vant';
    import { Loading } from 'vant';
    import { Dialog } from 'vant';
    import service from '../../server/index'
    export default {
        name: "RegisterDelivery",
        components:{
            [NavBar.name]: NavBar,
            [Form.name]:Form,
            [Field.name]:Field,
            [Button.name]:Button,
            [Toast.name]:Toast,
            [Dialog.Component.name]: Dialog.Component,
            [Overlay.name]: Overlay,
            [Loading.name]: Loading,
            [Checkbox.name]:Checkbox,
        },
        data(){
            return {
                personname:"",
                idcard:"",
                tel:"",
                msgCode:"",
                buttonTxt:"获取验证码",
                buttonStatus:false,
                smstime:0,
                timer:-1,
                show: false,
                checked:false
            }
        },
        methods:{
            back(){
                this.$router.replace("/Login")
            },
            sendMsg(){
                let myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
                if (this.tel == '') {
                    Toast('手机号码不能为空');
                    return false
                } else {
                    if (!myreg.test(this.tel)) {
                        Toast('手机号码格式不正确');
                        return false
                    }

                }

                let param={
                    phoneNumber:this.tel,
                    pre:'reg'
                }
                service.getRegisterCode(param).then(res=>{
                    if(res.code==200){
                        Toast('发送成功');

                    }else{
                        Toast('发送失败');
                    }

                }).catch(res=>{
                    alert(res);
                })

                this.smstime=15;
                this.buttonStatus=true;
                this.timer = setInterval(() => {          //
                    this.smstime--;
                    this.buttonTxt=this.smstime+"秒后重试";
                    if(this.smstime <= 0) {
                        this.smstime = 0
                        this.buttonStatus=false;
                        this.buttonTxt="重新获取"
                        clearInterval(this.timer);
                    }
                    // if(this.smstime==10){
                    //     Toast('假装验证码是435890');
                    // }
                }, 1000)
            },
            register(){

                let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                let myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
                if (this.personname == '') {
                    Toast('请输入姓名');
                    return false
                }
                if (this.idcard == '') {
                    Toast('请输入身份证号码');
                     return false
                } else {
                    if (!reg.test(this.idcard)) {
                        Toast('请输入正确格式的身份证号码');
                        return false
                    }
                }

                if (this.tel == '') {
                    Toast('请输入手机号码');
                    return false
                } else {
                    if (!myreg.test(this.tel)) {
                        Toast('请输入正确格式的手机号码');
                        return false
                    }

                }

                if (this.msgCode == '') {
                    Toast('请输入验证码');
                    return false
                }

                if(!this.checked){
                    Toast("请先阅读并同意《用户服务协议》");
                    return false;
                }


                let param={
                    personName:this.personname,
                    phoneNumber:this.tel,
                    idnumber:this.idcard,
                    wxOpenid:localStorage.getItem("openId"),
                    smsCode:this.msgCode,
                    pre:'reg'

                }
                service.registerCon(param).then(res=>{
                    if(res.code==200){
                        Dialog.alert({
                            title: '注册成功'
                        })
                        this.$router.replace('/login');

                    }else{
                        Dialog.alert({
                            title: '注册失败：'+res.msg,
                        })
                    }

                }).catch(res=>{
                    alert(res);
                })
            },
            showAgreement(){
                this.$router.replace("/Agreement")
            }
        }
    }
</script>

<style scoped lang="scss">
    .agreewarp{
        font-size: 14px;
        text-align: left;
        width: 90%;
        margin: 20px auto;
        a{
            color: #6685a4;
        }

        left: 0;
        right: 0;
        height: 30px;

    }
</style>

<style scoped >
    .block{
        width: 100%;
        height:100vh
    }
    .form-warp{
        width:90%;
        margin:10px auto 0px auto;
        font-size: 16px;
    }
    /deep/ .van-ellipsis{
        color: #6685a4;
    }
    /deep/ .van-nav-bar .van-icon{
        color: #6685a4;
    }

    /deep/ .van-nav-bar__text{
        color: #6685a4;
    }


</style>